var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskLevelUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 39,
    viewBox: "0 0 79 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0011 8.75617C22.3245 8.75617 8.75642 22.3239 8.75642 39H0C0.00218964 17.4948 17.4975 0 39.0011 0C60.5047 0 78.0022 17.4948 78.0022 39H69.2458C69.2458 22.3239 55.6777 8.75617 39.0011 8.75617Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.00219855,
    y1: 39,
    x2: 77.0022,
    y2: 39.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10BB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLevelUmbrella);
export default __webpack_public_path__ + "static/media/risk-level-umbrella.9b006629f80f29b0f876d5a5177e6e94.svg";
export { ForwardRef as ReactComponent };